/** Guest-realm no-op for the host-rendered Graph page (calendar/entry.js precedent). */
export const graphEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
